import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import MyStepper from "../../../../components/Stepper";
import AssetForm from "./assetForm";
import LiabilityForm from "./liabilityForm";
import StructureForm from "./structureForm";
import { steps1, steps } from "../../../../utility/data";
import { IoMdArrowBack } from "react-icons/io";
import { addAsset } from "../../../../services/addWealth/assetApi";
import { Toast } from "primereact/toast";
import { addStructure } from "../../../../services/addWealth/structureApi";
import { addLiablity } from "../../../../services/addWealth/liability";
import { ProgressSpinner } from "primereact/progressspinner";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchGroups,
  resetGroupsState,
} from "../../../../redux/slices/groupsSlice";
import {
  clearSelectedAsset,
  fetchUserAssets,
} from "../../../../redux/slices/userAssetsSlice";
import { useLocation } from "react-router-dom";
import { handleErrorRedirect } from "../../../../utility/errorRedirect";
import Breadcrumb from "../../../../components/Breadcrumb";
import { additems } from "../../../../services/transaction";
import moment from "moment";

const Home = () => {
  const heading = "What would you like to create today ?";
  const AssetsHeading = "Select the type of asset you want to add";

  const [currentStepGroup, setCurrentStepGroup] = useState(1);
  const [currentStep, setCurrentStep] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [selectedAssetType, setSelectedAssetType] = useState(null);
  const [loading, setLoading] = useState(false);

  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useRef(null);
  const { groupsData, groupLoading } = useSelector((state) => state.groups);
  const userAssets = useSelector((state) => state.userAssets.data);
  const location = useLocation();

  const handleBackClick = () => {
    if (showForm) {
      setShowForm(false);
      // Reset selected asset type when going back from asset form
      if (currentStepGroup === 2) {
        setSelectedAssetType(null);
      }
      // Reset current step when going back from liability/structure forms
      else if (currentStepGroup === 1) {
        setCurrentStep(0);
      }
    } else if (currentStepGroup === 2) {
      setCurrentStepGroup(1);
      setCurrentStep(0);
    }
  };

  const getBreadcrumbs = (
    stepGroup,
    step,
    selectedAssetType,
    setCurrentStepGroup
  ) => {
    const crumbs = [{ label: "Home", path: "/" }];

    if (stepGroup === 1) {
      switch (step) {
        case 0:
          crumbs.push({ label: "My view" });
          break;
        case 1:
          crumbs.push({
            label: "My view",
            onClick: () => {
              setShowForm(false);
              setCurrentStep(0);
            },
          });
          crumbs.push({ label: "Liability" });
          break;
        case 2:
          crumbs.push({
            label: "My view",
            onClick: () => {
              setShowForm(false);
              setCurrentStep(0);
            },
          });
          crumbs.push({ label: "Structure" });
          break;
      }
    } else if (stepGroup === 2) {
      crumbs.push({
        label: "My view",
        onClick: () => {
          setShowForm(false);
          setSelectedAssetType(null);
          setCurrentStepGroup(1);
        },
      });
      crumbs.push({
        label: "Assets Wealth",
        onClick: () => {
          setCurrentStepGroup(2);
          setShowForm(false);
          setSelectedAssetType(null);
        },
      });
      if (selectedAssetType?.name) {
        crumbs.push({ label: selectedAssetType.name });
      }
    }

    return crumbs;
  };

  const breadcrumbs = getBreadcrumbs(
    currentStepGroup,
    currentStep,
    selectedAssetType,
    setCurrentStepGroup
  );

  useEffect(() => {
    const assetTypeName = location?.state?.autoOpenAssetType;
    if (assetTypeName) {
      const assetTypeObj = steps1.find(
        (step) => step.name.toLowerCase() === assetTypeName.toLowerCase()
      );

      if (assetTypeObj) {
        setSelectedAssetType(assetTypeObj);
        setCurrentStepGroup(2);
        setCurrentStep(0);
        setShowForm(true);

        window.history.replaceState({}, document.title);
      }
    }
  }, [location?.state]);

  useEffect(() => {
    if (accessToken) {
      dispatch(fetchGroups(accessToken)).then((resultAction) => {
        if (fetchGroups.rejected.match(resultAction)) {
          const status = resultAction?.payload?.status;
          handleErrorRedirect(status, navigate);
        }
      });
      dispatch(fetchUserAssets({ assetTypeId: 1 })).then((resultAction) => {
        if (fetchUserAssets.rejected.match(resultAction)) {
          const status = resultAction?.payload?.status;
          handleErrorRedirect(status, navigate);
        }
      });
    }

    return () => {
      dispatch(resetGroupsState());
      dispatch(clearSelectedAsset());
    };
  }, [dispatch, accessToken, navigate]);

  const renderForm = () => {
    switch (currentStep) {
      case 0:
        return (
          <AssetForm
            assetType={selectedAssetType}
            onSubmit={handleAssetSubmit}
            loading={loading}
            setLoading={setLoading}
            groupsData={groupsData}
            userAssets={userAssets}
          />
        );
      case 1:
        return (
          <LiabilityForm
            onSubmit={handleLiabilitySubmit}
            loading={loading}
            groupsData={groupsData}
          />
        );
      case 2:
        return (
          <StructureForm
            onSubmit={handleStructureSubmit}
            loading={loading}
            groupsData={groupsData}
          />
        );
      default:
        return null;
    }
  };

  const handleStepSelection = (index, step) => {
    if (currentStepGroup === 1) {
      if (index === 0) {
        setCurrentStepGroup(2);
        setCurrentStep(0);
      } else {
        setCurrentStep(index);
        setShowForm(true);
      }
    } else if (currentStepGroup === 2) {
      setSelectedAssetType(steps1[index]);
      setShowForm(true);
    }
  };

  const handleAssetSubmit = async (assetData, assetTypeName) => {
  setLoading(true);

  const formattedData = {
    ...assetData,
    initialBalance: assetData.initialBalance
      ? assetData.initialBalance.replace(/[,']/g, "")
      : "",
    costPrice: assetData.costPrice
      ? assetData.costPrice.replace(/[,']/g, "")
      : "",
    date: assetData?.date
      ? new Date(assetData?.date).toLocaleDateString("en-CA")
      : null,
    multiples: assetData?.multiples
      ? assetData?.multiples.replace(/[,']/g, "")
      : "",
    ebitda: assetData?.ebitda ? assetData?.ebitda.replace(/[,']/g, "") : "",
    age: assetData?.age ? assetData?.age.replace(/[,']/g, "") : "",
    retirement: assetData?.retirement
      ? assetData?.retirement.replace(/[,']/g, "")
      : "",
    growthGrossSalary: assetData?.growthGrossSalary
      ? assetData?.growthGrossSalary.replace(/[,']/g, "")
      : "",
    maturityGrossSalary: assetData?.maturityGrossSalary
      ? assetData?.maturityGrossSalary.replace(/[,']/g, "")
      : "",
    annualReturn: assetData?.annualReturn
      ? assetData?.annualReturn.replace(/[,']/g, "")
      : "",
    growth: assetData?.growth ? assetData?.growth.replace(/[,']/g, "") : "",
    maturity: assetData?.maturity
      ? assetData?.maturity.replace(/[,']/g, "")
      : "",
    conversionRate: assetData?.conversionRate
      ? assetData?.conversionRate.replace(/[,']/g, "")
      : "",
    contributionYear: assetData?.contributionYear
      ? assetData?.contributionYear.replace(/[,']/g, "")
      : "",
    secondPillarAverageIncome: assetData?.secondPillarAverageIncome
      ? assetData?.secondPillarAverageIncome.replace(/[,']/g, "")
      : "",
    thirdPillarAverageIncome: assetData?.thirdPillarAverageIncome
      ? assetData?.thirdPillarAverageIncome.replace(/[,']/g, "")
      : "",
    contributionRate: assetData?.contributionRate
      ? assetData?.contributionRate.replace(/[,']/g, "")
      : "",
    AVSContribution: assetData?.AVSContribution
      ? assetData?.AVSContribution.replace(/[,']/g, "")
      : "",
    futureContribution3rdPillar: assetData?.futureContribution3rdPillar
      ? assetData?.futureContribution3rdPillar.replace(/[,']/g, "")
      : "",
    pastContribution3rdPillar: assetData?.pastContribution3rdPillar
      ? assetData?.pastContribution3rdPillar.replace(/[,']/g, "")
      : "",
  };

  try {
    // Step 1: Add Asset
    const response = await addAsset(formattedData, assetTypeName, accessToken);
    if (!response.data.status) {
      throw new Error(response.data.message || "Asset creation failed");
    }

    const assetId = response?.data?.data ?? null;

    // Step 2: If Luxury Asset → Add Initial Transaction
    if (assetTypeName === "Luxury Asset") {
      const addItemResponse = await additems(
        {
          ...formattedData,
          date: moment(formattedData.date).format("YYYY-MM-DD HH:mm:ss"),
          purchasePrice: formattedData.initialBalance,
        },
        assetId,
        accessToken
      );

      if (!addItemResponse.data.status) {
        throw new Error(addItemResponse.data.message || "Item save failed");
      }
    }

    // Step 3: If all succeeded → show success toast
    toast.current.show({
      className: "bg-green-300 text-white",
      severity: "success",
      summary: "Success",
      detail: "Asset and Transaction Saved Successfully",
      life: 3000,
    });

    // Step 4: Navigate
    setTimeout(() => {
      const formattedOption =
        typeof assetTypeName === "string"
          ? assetTypeName.toLowerCase().split(" ").join("-")
          : "unknown-option";
      navigate(`/view-${formattedOption}-transaction`, {
        state: {
          id: assetId,
        },
      });
    }, 1000);
  } catch (error) {
    const status = error?.response?.status;
    handleErrorRedirect(status, navigate);
    console.error("Error in asset save:", error);

    toast.current.show({
      className: "bg-yellow-700 text-white",
      severity: "warn",
      summary: "Warning",
      detail: error.message,
      life: 3000,
    });
  } finally {
    setLoading(false);
  }
};


  const handleStructureSubmit = async (structureData) => {
    setLoading(true);
    try {
      const response = await addStructure(structureData, accessToken);
      if (response.data.status === true) {
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: response.data.message,
          life: 3000,
        });
        setTimeout(() => {
          navigate("/");
        }, 1000);
      }
    } catch (error) {
      const status = error?.response?.status;
      handleErrorRedirect(status, navigate);
      console.error("Error adding structure:", error);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: error.message,
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleLiabilitySubmit = async (liabilityData) => {
    setLoading(true);
    try {
      const response = await addLiablity(liabilityData, accessToken);
      if (response.data.status === true) {
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: response.data.message,
          life: 3000,
        });
        setTimeout(() => {
          navigate("/");
        }, 1000);
      }
    } catch (error) {
      const status = error?.response?.status;
      handleErrorRedirect(status, navigate);
      console.error("Error adding liability:", error);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: error.message,
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAddItemSave = async (
    formatData,
    assetName,
    date,
    purchasePrice
  ) => {
    if (!assetName) {
      setLoading(false);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: "Please add the first initial transaction",
        life: 3000,
      });
      return;
    }

    const formattedData = {
      ...formatData,
      date: date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : null,
      purchasePrice: purchasePrice ? purchasePrice.replace(/[,']/g, "") : "",
    };
    try {
      const response = await additems(formattedData, assetName, accessToken);
      if (response.data.status === true) {
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: response.data.message,
          life: 3000,
        });
      }
    } catch (error) {
      const status = error?.response?.status;
      handleErrorRedirect(status, navigate);
      console.error("Error adding transaction:", error);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: error.message,
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <div
        className={`fixed top-28 left-8 ${
          currentStepGroup !== 1 || showForm ? "block" : "hidden"
        }`}
      >
        <button onClick={handleBackClick}>
          <IoMdArrowBack size={24} className="dark:text-grey text-info" />
        </button>
      </div>

      <Breadcrumb items={breadcrumbs} className="md:ml-6 mb-7" />

      {!showForm ? (
        <div className="flex justify-center items-center h-[calc(100vh-10rem)] p-2">
          <div className="text-2xl flex justify-center flex-col items-center gap-6">
            <MyStepper
              steps={
                currentStepGroup === 1
                  ? steps
                  : currentStepGroup === 2
                  ? steps1
                  : ""
              }
              heading={currentStepGroup === 2 ? AssetsHeading : heading}
              onStepSelect={handleStepSelection}
              currentStepGroup={currentStepGroup}
              currentStep={currentStep}
              selectedType={selectedAssetType ? selectedAssetType : ""}
            />
          </div>
        </div>
      ) : (
        <div className="w-full lg:px-24 lg:py-8 rounded-lg lg:px-16">
          {loading ? (
            <div className="flex justify-center items-center fixed inset-0">
              <ProgressSpinner style={{ width: "60px", height: "60px" }} />
            </div>
          ) : (
            renderForm()
          )}
        </div>
      )}
    </>
  );
};

export default Home;
